import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Cell,
} from "recharts";

const STEP_COLORS = {
  "1.1": "#2ECC71",
  "1.2": "#27AE60",
  "1.3": "#1F8B4C",
  "2.1": "#F1C40F",
  "2.2": "#FFD24D",
  "2.3": "#E1B12C",
  "2.4": "#C99700",
  "3.1": "#FF0000",
  "3.2": "#D50000",
  "3.3": "#B00020",
  unknown: "#8A87A8",
};

function getStepColor(stepRaw) {
  const step = String(stepRaw ?? "unknown");
  if (STEP_COLORS[step]) return STEP_COLORS[step];

  const major = Number(step.split(".")[0]);
  if (Number.isFinite(major)) {
    if (major <= 1) return "#2ECC71";
    if (major === 2) return "#F39C12";
    if (major >= 3) return "#E74C3C";
  }

  return STEP_COLORS.unknown;
}

function formatInt(n) {
  return Number(n || 0).toLocaleString("de-DE");
}

function formatPercent(n) {
  return `${Number(n || 0).toFixed(1)}%`;
}

function formatDays(n) {
  return `${Number(n || 0).toFixed(1)} d`;
}

export default function StepBarDiagram({ data = [], variant = "total" }) {
  if (!data.length) {
    return (
      <div className="analysis-diagram-empty">
        No data available for this chart.
      </div>
    );
  }

  const valueFormatter =
    variant === "percent"
      ? formatPercent
      : variant === "mttr"
        ? formatDays
        : formatInt;

  const tooltipValueLabel =
    variant === "percent"
      ? "Percent"
      : variant === "mttr"
        ? "Days"
        : "Cases";

  return (
    <div className="analysis-chart-area">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 10, right: 16, left: 0, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" opacity={0.15} />
          <XAxis dataKey="step" />
          <YAxis tickFormatter={valueFormatter} />

          <Tooltip
            formatter={(value) => [valueFormatter(value), tooltipValueLabel]}
            labelFormatter={(label) => `Step ${label}`}
            contentStyle={{
              background: "#151024",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 8,
              color: "#EDEBFF",
            }}
            itemStyle={{ color: "#EDEBFF" }}
            labelStyle={{ color: "#EDEBFF" }}
          />

          <Bar dataKey="value" radius={[6, 6, 0, 0]} isAnimationActive={false}>
            {data.map((entry) => (
              <Cell key={entry.step} fill={getStepColor(entry.step)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}